import { __awaiter, __generator } from "tslib";
import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import Home from '@/pages/public/Home.vue';
import Login from '@/pages/public/Login.vue';
import Register from '@/pages/public/Register.vue';
import Dashboard from '@/pages/Dashboard.vue';
import ClientList from '@/pages/admin/ClientList.vue';
import Groups from '@/pages/admin/Groups.vue';
import GroupForm from '@/pages/admin/GroupForm.vue';
import OrderPage from '@/pages/customer/OrderPage.vue';
import Platforms from '@/pages/admin/Platforms.vue';
import PlatformCreate from '@/pages/admin/PlatformCreate.vue';
import PlatformPage from '@/pages/public/PlatformPage.vue';
import UserList from '@/pages/admin/UserList.vue';
import PrivacityPage from '@/pages/public/PrivacityPage.vue';
import ProfilePage from '@/pages/ProfilePage.vue';
var routes = [
    /////////// Publicas
    { path: '/', name: 'Home', component: Home },
    { path: '/login', name: 'Login', component: Login },
    { path: '/registro', name: 'Register', component: Register },
    { path: '/plataformas/:id', name: 'Platforms.show', component: PlatformPage },
    { path: '/politicas-privacidad-y-condiciones-servicio', name: 'Privacity', component: PrivacityPage },
    /////////// Perfil
    { path: '/perfil', name: 'profile', component: ProfilePage, meta: { requiresAuth: true } },
    /////////// Clientes
    { path: '/pedido', name: 'Order', component: OrderPage, meta: { requiresAuth: true } },
    /////////// Administradores
    { path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: { requiresAuth: true } },
    { path: '/admin/clients', name: 'Clients', component: ClientList, meta: { requiresAuth: true } },
    { path: '/admin/platforms', name: 'Platforms', component: Platforms, meta: { requiresAuth: true } },
    { path: '/admin/platforms/create', name: 'Platforms.create', component: PlatformCreate, meta: { requiresAuth: true } },
    { path: '/admin/groups', name: 'Groups', component: Groups, meta: { requiresAuth: true } },
    { path: '/admin/groups/create', name: 'Groups.create', component: GroupForm, meta: { requiresAuth: true } },
    { path: '/admin/groups/edit/:id', name: 'Groups.edit', component: GroupForm, meta: { requiresAuth: true } },
    { path: '/admin/users', name: 'Users', component: UserList, meta: { requiresAuth: true } }
];
var router = createRouter({
    history: createWebHistory(),
    routes: routes
});
router.beforeEach(function (to, from, next) { return __awaiter(void 0, void 0, void 0, function () {
    var auth;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                auth = useAuthStore();
                if (!auth.loading) return [3 /*break*/, 2];
                return [4 /*yield*/, new Promise(function (resolve) {
                        var check = setInterval(function () {
                            if (!auth.loading) {
                                clearInterval(check);
                                resolve(null);
                            }
                        }, 100);
                    })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                if (to.name === 'Login' && auth.isAuthenticated) {
                    next('/dashboard');
                }
                else if (to.meta.requiresAuth && !auth.isAuthenticated) {
                    next('/login');
                }
                else {
                    next();
                }
                return [2 /*return*/];
        }
    });
}); });
export default router;
